import { Text, Flex } from "@chakra-ui/react";
import React from "react";

const HomeText = (props) => {
    if (props.isText) {
        return (
            <Text
                fontStyle="normal"
                fontWeight={300}
                fontSize={{ base: "0.87rem", md: "0.94rem" }}
                lineHeight={{ base: "1.20rem", md: "1.41rem" }}
                letterSpacing="-0.01rem"
                mt={props.mt}
                mb={props.mb}
                color={props.color}
            >
                {props.name}
            </Text>
        );
    } else if (props.isLabelText) {
        return (
            <Text
                fontStyle="normal"
                fontWeight={props.fontWeight}
                fontSize={props.fontSize}
                lineHeight={props.lineHeight}
                letterSpacing="-0.01rem"
                mt={props.mt}
                ml={props.ml}
                mb={props.mb}
                color={props.color}
                display="flex"
                alignItems={props.alignItems}
            >
                {props.name}
            </Text>
        );
    }
};

export default HomeText;
